import React from 'react';
import Section from '../Section';
import styles from './HowItWorks.module.scss';

export interface ProcessStepItem {
  step: string;
  title: string;
  description: string;
}

export interface HowItWorksProps {
  title?: string;
  subtitle?: string;
  steps?: ProcessStepItem[];
  background?: 'default' | 'surface';
}

export const HOW_IT_WORKS_STEPS: ProcessStepItem[] = [
  {
    step: '01',
    title: 'Tell us about your business',
    description: 'Short questionnaire + content/images.',
  },
  {
    step: '02',
    title: 'We build it',
    description: "You don't need to worry about the technical side.",
  },
  {
    step: '03',
    title: 'You review it',
    description: 'We make the agreed revisions.',
  },
  {
    step: '04',
    title: 'We launch it',
    description: 'Hosting, DNS, SSL and deployment handled.',
  },
  {
    step: '05',
    title: 'We look after it',
    description: 'The website stays hosted and you can request future changes.',
  },
];

export const HowItWorks: React.FC<HowItWorksProps> = ({
  title = 'How it works',
  subtitle = 'Our simple, transparent process to get your business online.',
  steps = HOW_IT_WORKS_STEPS,
  background = 'surface',
}) => {
  return (
    <Section background={background}>
      <div className={styles.howItWorksSection}>
        <div className={styles.howItWorksHeader}>
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        <div className={styles.processGrid}>
          {steps.map((item, index) => (
            <div key={index} className={styles.processCard}>
              <div className={styles.stepNumber}>{item.step}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default HowItWorks;
export * from './HowItWorks';
